import React, { Component } from 'react'
import styled from 'styled-components'
import { Formik } from 'formik'
import { Mutation } from 'react-apollo'
import { withStyles } from 'material-ui/styles'
import TextField from 'material-ui/TextField'
import IconButton from 'material-ui/IconButton'
import NovoSubmit from 'svgs/NovoSubmit'
import Yup from 'yup'
import CONTACT_NOVO_LABS from 'graphql/contactNovoLabs'

class ContactForm extends Component {
  state = {
    successfulSubmission: false,
  }

  updateSubmissionStatus() {
    this.setState({
      successfulSubmission: true,
    })
  }

  resetSubmissionStatus() {
    this.setState({
      successfulSubmission: false,
    })
  }

  render() {
    const { classes } = this.props
    return (
      <Mutation
        mutation={CONTACT_NOVO_LABS}
        onCompleted={() => {
          this.updateSubmissionStatus()
        }}
      >
        {(contactNovoLabs, { loading, error }) => (
          <div style={{ height: '100%' }}>
            <Formik
              initialValues={{
                email: '',
                name: '',
                message: '',
                subject: '',
              }}
              onSubmit={(values, { setSubmitting }) => {
                contactNovoLabs({ variables: { newEmail: values } })
                  .then(() => setSubmitting(false))
                  .catch(() => setSubmitting(false))
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string()
                  .email('Invalid email ddress')
                  .required('Email is required'),
                name: Yup.string().required('Name is required'),
                subject: Yup.string().required('Subject is required'),
                message: Yup.string().required('Message is required'),
              })}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                handleReset,
                touched,
                values,
                errors,
                dirty,
                isSubmitting,
              }) => {
                return (
                  <form
                    id="contactForm"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end',
                    }}
                    onSubmit={handleSubmit}
                  >
                    <TextField
                      fullWidth={true}
                      name="name"
                      inputProps={{ maxLength: '50' }}
                      // eslint-disable-next-line
                      InputProps={{
                        classes: {
                          input: classes.input,
                          underline: classes.inputUnderline,
                        },
                      }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="name"
                      type="text"
                      value={values.name}
                    />
                    {errors.name && touched.name && (
                      <div style={{ color: 'indianred' }}>{errors.name}</div>
                    )}
                    <TextField
                      fullWidth={true}
                      name="email"
                      inputProps={{ maxLength: '75' }}
                      // eslint-disable-next-line
                      InputProps={{
                        classes: {
                          input: classes.input,
                          underline: classes.inputUnderline,
                        },
                      }}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="email"
                      type="email"
                      value={values.email}
                    />
                    {errors.email && touched.email && (
                      <div style={{ color: 'indianred' }}>{errors.email}</div>
                    )}
                    <TextField
                      fullWidth={true}
                      inputProps={{ maxLength: '80' }}
                      // eslint-disable-next-line
                      InputProps={{
                        classes: {
                          input: classes.input,
                          underline: classes.inputUnderline,
                        },
                      }}
                      name="subject"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder="subject"
                      type="text"
                      value={values.subject}
                    />
                    {errors.subject && touched.subject && (
                      <div style={{ color: 'indianred' }}>{errors.subject}</div>
                    )}
                    <TextField
                      fullWidth={true}
                      name="message"
                      inputProps={{ maxLength: '500' }}
                      // eslint-disable-next-line
                      InputProps={{
                        classes: {
                          input: classes.input,
                          underline: classes.inputUnderline,
                        },
                      }}
                      multiline={true}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      rows={2}
                      rowsMax={6}
                      placeholder="message"
                      type="text"
                      value={values.message}
                    />
                    {errors.message && touched.message && (
                      <div style={{ color: 'indianred' }}>{errors.message}</div>
                    )}
                    <div>
                      <IconButton
                        classes={{
                          root: classes.root,
                        }}
                        disabled={isSubmitting}
                        type="submit"
                      >
                        <NovoSubmit />
                      </IconButton>
                    </div>
                  </form>
                )
              }}
            </Formik>
            {loading && <SubmitStatus>submitting...</SubmitStatus>}
            {error && (
              <SubmitStatus>
                error: =( please try again in a few minutes
              </SubmitStatus>
            )}
            {this.state.successfulSubmission && (
              <SubmitStatus>
                Thanks for your email. We will be in contact soon!
              </SubmitStatus>
            )}
          </div>
        )}
      </Mutation>
    )
  }
}

const SubmitStatus = styled.p`
  color: white;
  font-family: 'Pangram Extra Bold'
  margin: auto;
  text-align: center;
`

const inputPlaceholder = {
  color: 'white',
  opacity: 0.7,
}

const bottomLineColor = 'var(--novo-green)'

const styles = theme => {
  return {
    root: {
      flex: '0',
      display: 'inline-block',
      height: 72,
      width: 72,
    },
    buttonRoot: {
      color: 'white',
      margin: '16px 16px 16px 0',
    },
    buttonLabel: {
      textTransform: 'lowercase',
    },
    input: {
      color: 'white',
      '&::-webkit-input-placeholder': inputPlaceholder,
      '&::-moz-placeholder': inputPlaceholder, // Firefox 19+
      '&:-ms-input-placeholder': inputPlaceholder, // IE 11
      '&::-ms-input-placeholder': inputPlaceholder, // Edge
    },
    inputUnderline: {
      '&:after': {
        backgroundColor: 'var(--novo-dark-gray)',
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 2,
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut,
        }),
      },
      '&:before': {
        backgroundColor: bottomLineColor,
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        height: 2,
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('background-color', {
          duration: theme.transitions.duration.shorter,
        }),
        pointerEvents: 'none', // Transparent to the hover style.
      },
    },
  }
}

export default withStyles(styles, { withTheme: true })(ContactForm)



// WEBPACK FOOTER //
// ./src/components/ContactForm.js